import { showModal } from '@/redux/reducers/modalsSlice';

import { flagsSVG } from '../Assets/icons';

import { MODAL_CREATE_ACCOUNT, MODAL_MAKE_COPY } from './constants';
import { hasNoWritePermission } from '@/helpers/spreadsheetHelper';

const getFlagSubMenu = (
  params,
  flagRows,
  dispatch,
  user,
  currentFile,
  isPreviewMode,
  showPreviewModeUpsellModal
) => {
  const subMenu = [];
  const flag = +params.node.data.metadata_tag;
  for (let i = 0; i < 4; i++) {
    const subMenuItem = {
      action:
        hasNoWritePermission(currentFile) && !user?.is_anonymous
          ? () => dispatch(showModal({ name: MODAL_MAKE_COPY }))
          : user?.is_anonymous
          ? () => dispatch(showModal({ name: MODAL_CREATE_ACCOUNT }))
          : isPreviewMode
          ? () => {
              return showPreviewModeUpsellModal();
            }
          : () => flagRows(params, i),
    };
    if (i === 0) {
      subMenuItem.name = 'None';
      subMenuItem.icon = `<img id="flag-none" src=${flagsSVG.GoodFlagIcon} alt="flag as none" class="context-menu-flag-item-none-icon"/>`;
      if (flag === i) {
        subMenuItem.icon = `<img src=${flagsSVG.GoodFlagIcon} alt="flag as none" class="context-menu-flag-item-none-icon"/>
        <img src=${flagsSVG.FlagCheckIcon} alt="no flag" class="context-menu-flag-check-item-icon"/>`;
      }
    }
    if (i === 1) {
      subMenuItem.name = 'Good';
      subMenuItem.icon = `<img id="flag-good" src=${flagsSVG.GoodFlagIcon} alt="flag as good" class="context-menu-flag-item-icon"/>`;
      if (flag === i) {
        subMenuItem.icon = `<img src=${flagsSVG.GoodFlagIcon} alt="flag as good" class="context-menu-flag-item-icon"/>
        <img src=${flagsSVG.FlagCheckIcon} alt="flag as good" class="context-menu-flag-check-item-icon"/>`;
      }
    }
    if (i === 2) {
      subMenuItem.name = 'Suspicious';
      subMenuItem.icon = `<img id="flag-suspicious" src=${flagsSVG.SuspiciousFlagIcon} alt="flag as suspicious" class="context-menu-flag-item-icon"/>`;
      if (flag === i) {
        subMenuItem.icon = `<img src=${flagsSVG.SuspiciousFlagIcon} alt="flag as suspicious" class="context-menu-flag-item-icon"/>
        <img src=${flagsSVG.FlagCheckIcon} alt="flag as good" class="context-menu-flag-check-item-icon"/>`;
      }
    }
    if (i === 3) {
      subMenuItem.name = 'Bad';
      subMenuItem.icon = `<img id="flag-bad" src=${flagsSVG.BadFlagIcon} alt="flag as bad" class="context-menu-flag-item-icon"/>`;
      if (flag === i) {
        subMenuItem.icon = `<img src=${flagsSVG.BadFlagIcon} alt="flag as bad" class="context-menu-flag-item-icon"/>
        <img src=${flagsSVG.FlagCheckIcon} alt="flag as good" class="context-menu-flag-check-item-icon"/>`;
      }
    }
    subMenu.push(subMenuItem);
  }

  return subMenu;
};

export default getFlagSubMenu;
